import script from "./termsOfService.vue?vue&type=script&setup=true&lang=js"
export * from "./termsOfService.vue?vue&type=script&setup=true&lang=js"

import "./termsOfService.vue?vue&type=style&index=0&id=43157c5f&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43157c5f"]])

export default __exports__